
import login from '@/views/user/loginPage.vue';
import main from '@/views/main/mainPage.vue';
import search from '@/views/main/searchPage.vue';

const routes = [
  {
    path: '/login',
    name: 'login',
    component:login,// () => import('../views/user/loginPage.vue'),
    meta: {
      title: '登录页'
    }
  },
  {
    path: '/main',
    name: 'main',
    component:main,// () => import('../views/main/mainPage.vue'),
    meta: {
      title: '防汛通',
	   keepAlive: false, // 需要缓存的组件
    }
  },
  {
    path: '/search',
    name: 'search',
    component:search,// () => import('../views/main/searchPage.vue'),
    meta: {
      title: '搜索结果',
	   keepAlive: false // 需要缓存的组件
    }
  },
  {
    path: '/detail',
    name: 'detail',
    component: () => import('../views/main/detail.vue'),
    meta: {
      title: '预览文件', 
	   keepAlive: false, // 需要缓存的组件
    }
  }, 
  {
    path: '/sdetail',
    name: 'sdetail',
    component: () => import('../views/main/sdetail.vue'),
    meta: {
      title: '预览文件', 
	   keepAlive: false,
    }
  }, 
  
]
export default routes;